import { render, staticRenderFns } from "./membersInfo.vue?vue&type=template&id=2bb0c725"
import script from "./membersInfo.vue?vue&type=script&lang=js"
export * from "./membersInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports